import React, { useState, useEffect } from "react";
import EmployeeForm from "./EmployeeForm";
import { Column, Row } from "simple-flexbox";
import {
  Paper,
  makeStyles,
  TableBody,
  TableRow,
  TableCell,
  Toolbar,
  InputAdornment,
} from "@material-ui/core";
import "./employee.styles.scss";
import useTable from "../../../utilities/useTable";
import * as employeeService from "../../../../services/employeeService";
import StatComponent from "../../stat-page/StatComponent";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import Controls from "../../../controls/Controls";
import { Search } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import Popup from "../../../utilities/Popup";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import EditLocationOutlined from "@material-ui/icons/EditLocationOutlined";
import CloseIcon from "@material-ui/icons/Close";
import Notification from "../../../utilities/Notification";
import ConfirmDialog from "../../../utilities/ConfirmDialog";
import AddEmployeeForm from "./AddEmployeForm";
import UserLocationForm from "./UserLocationForm";

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(5),
    padding: theme.spacing(3),
  },
  searchInput: {
    width: "75%",
  },
  newButton: {
    position: "absolute",
    right: "10px",
  },
}));

const headCells = [
  { id: "fullName", label: "Employee Name" },
  { id: "LastName", label: "Last Name" },
  { id: "mobile", label: "Mobile Number" },
  { id: "actions", label: "Actions", disableSorting: true },
];

export function Employees({
  users,
  UpdateUser,
  roles,
  LoadUsers,
  cacNumber,
  AddUser,
  userType,
}) {
  const classes = useStyles();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [addOpenPopup, setAddOpenPopup] = useState(false);
  const [userLocationOpenPopup, setuserLocationOpenPopup] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  var roles = roles;
  var viewRoles = ["App Owner"];

  const verifyRoles = () => {
    var i = 0;
    var actualRole = roles[0];
    for (i = 0; i < viewRoles.length; i++) {
      if (viewRoles[i] == actualRole) {
        return true;
      }
    }
    return false;
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(users.length == 0 ? users : users.userInfo, headCells, filterFn);

  useEffect(() => {
    LoadUsers(cacNumber);
    return () => {};
  }, []);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) =>
            x.firstName.toLowerCase().includes(target.value)
          );
      },
    });
  };

  const addOrEdit = (employee, resetForm) => {
    if (employee.id === 0) AddUser(employee);
    else var data = { ...employee, userId: employee.id };
    UpdateUser(data);
    resetForm();
    setOpenPopup(false);
    setAddOpenPopup(false);
    setNotify({
      isOpen: true,
      message: "Submitted Successfully",
      type: "success",
    });
  };

  const addEmployee = (employee, resetForm) => {
    AddUser(employee);
    resetForm();
    setRecordForEdit(null);
    setOpenPopup(false);
    setAddOpenPopup(false);
  };

  const openInPopup = (item) => {
    setRecordForEdit(item);
    setOpenPopup(true);
  };
  const userLocationInPopup = (item) => {
    setRecordForEdit(item);
    setuserLocationOpenPopup(true);
  };

  const onDelete = (id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    employeeService.deleteEmployee(id);
    var record = employeeService.getAllEmployees();
  };
  return (
    <>
      <div
        className="container"
        style={{
          width: "100rem",
          position: "relative",
          left: "-1rem",
          top: "-1rem",
        }}
      >
        <div>
          {verifyRoles() ? (
            <Column flexGrow={1}>
              <ToastContainer />
              <div style={{ position: "relative", left: "2.5rem" }}>
                <Controls.Input
                  // label="Search Employees"
                  placeholder="Search Employees"
                  className={classes.searchInput}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                  }}
                  onChange={handleSearch}
                />
              </div>
              <Paper className={classes.pageContent}>
                <Toolbar>
                  {verifyRoles() ? (
                    <Controls.Button
                      text="Add New"
                      variant="outlined"
                      startIcon={<AddIcon />}
                      className={classes.newButton}
                      onClick={() => {
                        setAddOpenPopup(true);
                        setRecordForEdit(null);
                      }}
                    />
                  ) : (
                    ""
                  )}
                </Toolbar>

                <TblContainer>
                  <TblHead />
                  <TableBody>
                    {recordsAfterPagingAndSorting().map((item) => (
                      <TableRow key={item.id}>
                        <TableCell>{item.firstName}</TableCell>
                        <TableCell>{item.lastName}</TableCell>
                        <TableCell>{item.phoneNumber}</TableCell>
                        <TableCell>
                          {/* <Controls.ActionButton
                            color="primary"
                            onClick={() => {
                              openInPopup(item);
                            }}
                          >
                            <EditOutlinedIcon fontSize="small" />
                          </Controls.ActionButton> */}
                          <Controls.ActionButton
                            color="primary"
                            onClick={() => {
                              userLocationInPopup(item);
                            }}
                          >
                            <EditLocationOutlined fontSize="small" />
                          </Controls.ActionButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </TblContainer>
                <TblPagination />
              </Paper>
              <Popup
                title="Employee Form"
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
              >
                <EmployeeForm
                  recordForEdit={recordForEdit}
                  addOrEdit={addOrEdit}
                  roles={users.roles}
                />
              </Popup>

              <Popup
                title="Update User Location"
                openPopup={userLocationOpenPopup}
                setOpenPopup={setuserLocationOpenPopup}
              >
                <UserLocationForm
                  recordForEdit={recordForEdit}
                  userId={localStorage.getItem("userId")}
                  setOpenPopup={setuserLocationOpenPopup}
                />
              </Popup>
              <Popup
                title="Add Employee Form"
                openPopup={addOpenPopup}
                setOpenPopup={setAddOpenPopup}
              >
                <AddEmployeeForm
                  recordForEdit={recordForEdit}
                  addEmployee={addEmployee}
                  userType={userType}
                  cacNumber={cacNumber}
                  roles={users.roles}
                />
              </Popup>
              <Notification notify={notify} setNotify={setNotify} />
              <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
              />
            </Column>
          ) : (
            <StatComponent />
          )}
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    buttonloader: state.utilityReducer.buttonloader,
    user: state.userReducer.user,
    cacNumber: state.userReducer.cacNumber,
    users: state.usersReducer.users,
    userType: state.userReducer.userType,
    roles: state.persistReducer.roles,
  };
}
const mapDispatchToProps = (dispatch) => ({
  UpdateUser(payload) {
    dispatch({ type: "UPDATE_USER", payload });
  },

  LoadUsers(payload) {
    dispatch({ type: "LOAD_USERS", payload });
  },
  AddUser(payload) {
    dispatch({ type: "ADD_USER", payload });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Employees);
